module.exports = __webpack_public_path__ + "img/34e-config-modelos-doc-wizard-assuntos.0a3c809f.png";